module.exports = __webpack_public_path__ + "media/images/emblems/Rossiniere-coat_of_arms-2d8aa1cc4f1c70e15f0d0a42f38121cc.svg";